import {
  getAllUsers,
  deleteUser,
  updateUser,
  createUser,
} from "../../../api/user";
import BootstrapTable from "./CommanPage";

const Users = () => {
  const USER_FIELD = [
    {
      name: "firstName",
      label: "First Name",
      type: "text",
      placeholder: "Enter your First Name",
      isForm: true,
      isTable: true,
      validation: {
        required: "First Name is required",
        minLength: {
          value: 3,
          message: "Minimum 3 characters",
        },
      },
    },
    {
      name: "lastName",
      label: "Last Name",
      type: "text",
      placeholder: "Enter your Last Name",
      isForm: true,
      isTable: true,
      validation: {
        required: "Last Name is required",
        minLength: {
          value: 3,
          message: "Minimum 3 characters",
        },
      },
    },
    {
      name: "mobile",
      label: "Mobile Number",
      type: "tel",
      placeholder: "Enter your mobile number",
      isForm: true,
      isTable: true,
      validation: {
        required: "Mobile number is required",
        pattern: {
          value: /^\d{7,15}$/,
          message: "Invalid mobile number",
        },
      },
    },
    {
      name: "email",
      label: "Email",
      type: "email",
      placeholder: "Enter your email",
      isForm: true,
      isTable: true,
      validation: {
        required: "Email is required",
        pattern: {
          value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
          message: "Invalid email address",
        },
      },
    },

    // {
    //   name: "password",
    //   label: "Password",
    //   type: "password",
    //   placeholder: "Enter your password",
    //   isForm: true,
    //   isTable: false,
    //   validation: {
    //     required: "Password is required",
    //     minLength: {
    //       value: 8,
    //       message: "Minimum 8 characters",
    //     },
    //   },
    // },
    // {
    //   name: "username",
    //   label: "Username",
    //   type: "text",
    //   placeholder: "Enter your username",
    //   isForm: true,
    //   isTable: true,
    //   validation: {
    //     required: "Username is required",
    //     minLength: {
    //       value: 3,
    //       message: "Minimum 3 characters",
    //     },
    //   },
    // },
    {
      name: "userType",
      label: "User Type",
      type: "select",
      isForm: true,
      isTable: true,
      options: [
        { value: "admin", label: "Admin" },
        { value: "user", label: "User" },
      ],
      validation: {
        required: "User type is required",
      },
    },
    {
      name: "isActive",
      label: "Active",
      type: "checkbox",
      isForm: true,
      isTable: true,
      render: (val) => (val ? "✅ Active" : "❌ Inactive"),
    },
    {
      name: "createdAt",
      label: "Created At",
      type: "text",
      isForm: false,
      isTable: true,
      render: (val) => new Date(val).toLocaleString(),
    },
    {
      name: "updatedAt",
      label: "Updated At",
      type: "text",
      isForm: false,
      isTable: true,
      render: (val) => new Date(val).toLocaleString(),
    },
  ];
  return (
    <BootstrapTable
      fields={USER_FIELD}
      title={"Users"}
      getAllRecord={getAllUsers}
      deleteRecord={deleteUser}
      updateRecord={updateUser}
      createRecord={createUser}
      searchAble={true}
    />
  );
};

export default Users;
